import { Dict_str_int, userdata } from "./table_typing"

export interface tableState {
    model:{
            user:userdata,
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        user: {
            num_CVE_entries:0, 
      num_DNS_entries:0,
      num_NEWS_entries:0,
      mails_send:0,
      mails_unsent:0,
      latest_NEWS_entries:"",
      num_licenses_entries:0,
      num_licenses_active_entries:0,
      num_CPE_entries:0,
      versions_is_use:[] as Dict_str_int[],
      num_EUVD_entries:0,
      num_EUVD_exploited:0,
      euvd_synced_until:null as string|null,
      last_CVE_check:null as string|null,
      num_CIS_benchmarks:0,
      num_CIS_recommendations:0,
      num_CIS_rules:0,
      cis_last_import:null as string|null,
        }
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            // Every field, the new ones included. The list written out by
            // hand copied num_licenses_entries into num_licenses_active_entries.
            user:{ ...toCopy.model.user },
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}